export const CMS_PAGE_SLUG_HOME = 'shopfront-landing-page';
